import styles from "./halloween-modal.module.scss";
import FilledButton from "@/components/common/filled-button";
import Link from "next/link";
import TimeLeftBox from "@/components/modal/halloween-modal/components/time-left-box";
import { useHalloweenCountdown } from "@/components/modal/halloween-modal/hooks/use-halloween-countdown";
import HalloweenFeaturesList from "@/components/modal/halloween-modal/components/halloween-features-list";
import { useClipboard } from "@/hooks/use-clipboard";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
export const halloweenModalStorageKey = "halloweenModalShown";

const discountCode = "halloween";

const HalloweenModal = () => {
  const { timeLeft } = useHalloweenCountdown();
  const { copyToClipboard } = useClipboard();
  const { hideModal } = useGlobalModalContext();
  localStorage.setItem(halloweenModalStorageKey, "true");
  return (
    <div className={styles.halloween_modal}>
      <div className={styles.titles}>
        <div className={styles.modal_title}>
          <span>Upgrade</span> today for <span>60% off</span>!
        </div>
        <div className={styles.subtitle}>Upgrade today to unlock</div>
      </div>

      <HalloweenFeaturesList />
      <div className={styles.time_left_wrapper}>
        <TimeLeftBox title={"Days"} value={timeLeft?.days} />
        <TimeLeftBox title={"Hours"} value={timeLeft?.hours} />
        <TimeLeftBox title={"Minutes"} value={timeLeft?.minutes} />
        <TimeLeftBox title={"Seconds"} value={timeLeft?.seconds} />
      </div>

      <div className={styles.discount_code}>
        <div>
          Discount code: <span>{discountCode}</span>
        </div>
        <button
          className={styles.copy_button}
          onClick={() => copyToClipboard(discountCode, true)}
        >
          Copy to clipboard
        </button>
      </div>
      <Link href={"/pricing"}>
        <FilledButton text={"Upgrade Today"} onClick={hideModal} />
      </Link>
    </div>
  );
};

export default HalloweenModal;
